import { useIsMobile } from '@/hooks/useWindowDimensions';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';

function SessionBarTitle() {
  const isMobile = useIsMobile();
  const { t } = useTranslations();

  // On mobile, the header (with back button) is handled by MobileSidebar
  // We only render the title for desktop
  if (isMobile) {
    return null;
  }

  return <TypographyP2Bold>{t('sessions.title')}</TypographyP2Bold>;
}

SessionBarTitle.displayName = 'SessionBarTitle';
export default SessionBarTitle;
